import { createAsyncThunk } from "@reduxjs/toolkit";
import bandsService from "../../../api/services/bands";

export const getBands = createAsyncThunk(
  "bands/get-bands",
  async ({ page, search, limit }) => {
    return await bandsService.getBands({ page, search, limit });
  }
);

export const getAdminBands = createAsyncThunk(
  "bands/get-admin-bands",
  async ({ page, search, limit }) => {
    return await bandsService.getBands({ page, search, limit });
  }
);

export const getBandById = createAsyncThunk(
  "bands/get-band-by-id",
  async (id) => {
    return await bandsService.getBandById(id);
  }
);

export const getBandsForDropdown = createAsyncThunk(
  "bands/get-bands-for-dropdown",
  async () => {
    return await bandsService.getBandsForDropdown();
  }
);

export const getFeaturedBands = createAsyncThunk(
  "bands/get-featured-bands",
  async () => {
    return await bandsService.getFeaturedBands();
  }
);

export const getTopBandsByRevenue = createAsyncThunk(
  "bands/get-bands-by-revenue",
  async () => {
    return await bandsService.getTopBandsByRevenue();
  }
);

export const createBand = createAsyncThunk(
  "bands/create-band",
  async (requestData) => {
    return await bandsService.createBand(requestData);
  }
);

export const editBand = createAsyncThunk(
  "bands/edit-band",
  async ({ id, requestData }) => {
    return await bandsService.editBand({ id, requestData });
  }
);

export const deleteBand = createAsyncThunk("bands/delete-band", async (id) => {
  return await bandsService.deleteBand(id);
});

export const toggleBandStatus = createAsyncThunk(
  "bands/toggle-band-status",
  async (id) => {
    return await bandsService.toggleBandStatus(id);
  }
);

// DASHBOARD PRISTUP

export const createDashboardAccess = createAsyncThunk(
  "bands/create-dashboard-access",
  async ({ bandId, username, password }) => {
    return await bandsService.createDashboardAccess({
      bandId,
      username,
      password,
    });
  }
);

export const fetchAdminCredentials = createAsyncThunk(
  "bands/fetchAdminCredentials",
  async (bandId, thunkAPI) => {
    try {
      const data = await bandsService.getAdminCredentials(bandId);
      return { bandId, adminCredentials: data.adminCredentials };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const resetDashboardPassword = createAsyncThunk(
  "bands/reset-dashboard-password",
  async ({ bandId, newPassword }) => {
    return await bandsService.resetDashboardPassword({ bandId, newPassword });
  }
);

export const removeDashboardAccess = createAsyncThunk(
  "bands/remove-dashboard-access",
  async (bandId) => {
    return await bandsService.removeDashboardAccess(bandId);
  }
);

// Analytics

export const getBandAnalytics = createAsyncThunk(
  "bands/get-band-analytics",
  async (id) => {
    return await bandsService.getBandAnalytics(id);
  }
);

export const getBandProductAnalytics = createAsyncThunk(
  "bands/get-band-product-analytics",
  async ({ id, limit }) => {
    return await bandsService.getBandProductAnalytics({ id, limit });
  }
);

export const getProductsByBand = createAsyncThunk(
  "bands/get-products-by-band",
  async ({ id, page, limit, search }) => {
    return await bandsService.getProductsByBand({ id, page, limit, search });
  }
);

// BAND DETAILS ASYNC THUNKS

export const getBandDetails = createAsyncThunk(
  "bands/get-band-details",
  async (id, { rejectWithValue }) => {
    try {
      const response = await bandsService.getBandDetails(id);

      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in getBandDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getBandPublicDetails = createAsyncThunk(
  "bands/get-band-public-details",
  async (id) => {
    return await bandsService.getBandPublicDetails(id);
  }
);

export const getBandByName = createAsyncThunk(
  "bands/get-band-by-name",
  async (name) => {
    return await bandsService.getBandByName(name);
  }
);

export const updateBandDetails = createAsyncThunk(
  "bands/update-band-details",
  async ({ id, data, isFormData }, { rejectWithValue }) => {
    try {
      const response = await bandsService.updateBandDetails({
        id,
        data,
        isFormData,
      });

      return response;
    } catch (error) {
      console.error("AsyncThunk: Error in updateBandDetails:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
